import { api } from './_http';
type AppVersionResponseType = {
	AOS: string;
	IOS: string;
};

export const fetchGetAppVersionApi = async () => {
	const url = '/v1/front/getAppVersion';
	const res = await api.get<{ success: boolean; data: AppVersionResponseType }>(url);
	return res;
};
